import { isEmpty } from 'lodash-es';
import { css } from 'styled-components';

export const getClearCustomStyles =
  () =>
    ({ theme }: { theme: Record<string, any> }) => {
      const baseObject = theme?.hcp?.clear;
      if (isEmpty(baseObject)) return;

      return css`
      [class*='-addons-wrapper'] span[data-testid='delete'] {
        background-color: transparent;

        &::before {
          width: ${baseObject?.base?.width};
          height: ${baseObject?.base?.height};
          padding: ${baseObject?.base?.padding};
          border-radius: ${baseObject?.base?.borderRadius};
          background-color: ${baseObject?.base?.backgroundColor};
          cursor: ${baseObject?.base?.cursor};
          transition: ${baseObject?.transition};
        }

        &:hover {
          &::before {
            background-color: ${baseObject?.hover?.backgroundColor};
          }
        }

        &:active {
          &::before {
            background-color: ${baseObject?.active?.backgroundColor};
          }
        }
      }
    `;
    };
